import axios from 'axios';
import { DevicePreviewBuilder } from '@beef/shop-common';
import { captureException } from '@sentry/react';

import { cookiesDataService } from 'services/cookiesDataService';
import { COOKIES_NAMES } from 'constants/cookies';
import { getBasketProductIds } from 'store/common/basket/selectors';
import { getCurrentRegionId } from 'store/common/settings/selectors';
import pushEvent, { EVENT_CATALOG_POPUP_DETAILS_OPEN } from 'pushEvent';

import { DETAILS_MODAL_ACTIONS } from './constants';

// FETCH DATA ACTIONS
export const fetchDeviceDetailsDataStart = () => ({
  type: DETAILS_MODAL_ACTIONS.FETCH_DETAILS_MODAL,
});

export const fetchDeviceDetailsDataSuccess = (payload) => ({
  type: DETAILS_MODAL_ACTIONS.FETCH_DETAILS_MODAL_SUCCESS,
  payload,
});

export const fetchDeviceDetailsDataError = () => ({
  type: DETAILS_MODAL_ACTIONS.FETCH_DETAILS_MODAL_ERROR,
});

export const setDeviceDetailsIsFavoriteData = (payload) => ({
  type: DETAILS_MODAL_ACTIONS.SET_DEVICE_IS_FAVORITE,
  payload,
});

export const setDeviceDetailsIsCompareData = (payload) => ({
  type: DETAILS_MODAL_ACTIONS.SET_DEVICE_IS_COMPARE,
  payload,
});

export const setCurrentDevicePosition = (payload) => ({
  type: DETAILS_MODAL_ACTIONS.SET_DEVICE_POSITION,
  payload,
});

export const fetchDeviceDetailsData = (slug) => async (dispatch, getState) => {
  try {
    const state = getState();
    const basketIds = getBasketProductIds(state);
    dispatch(fetchDeviceDetailsDataStart());

    // TODO поменять слаг при вызове
    const currentSlug = slug.includes('/shop/details') ? slug.replace('/shop/details', '') : slug;

    const { data } = await axios.get(`/shop/popupdetails/${currentSlug}/`);
    const article = data?.article;
    const impression = data?.impression;

    let memory = '-';
    // eslint-disable-next-line
    data?.characteristics?.detailed?.forEach((char) => {
      if (char.group === 'Память') {
        memory = char?.list[0]?.value;
      }
    });

    const activeColor = data?.colors?.find((color) => color?.isActive)?.title || '-';
    const variant = `${activeColor}_${memory}`;
    const category = data?.mainCollectionName?.toString();

    pushEvent(EVENT_CATALOG_POPUP_DETAILS_OPEN, {
      name: impression?.name,
      id: impression?.id,
      price: impression?.price,
      brand: impression?.brand,
      variant,
      article,
      category,
    });

    const favoriteList = cookiesDataService.getDataList(COOKIES_NAMES.FAVORITE_DEVICES);
    const compareList = cookiesDataService.getDataList(COOKIES_NAMES.COMPARISON_DEVICES);

    const devicePreviewBuilder = new DevicePreviewBuilder();

    const currentRegion = getCurrentRegionId(state);

    devicePreviewBuilder.setDeviceId(data);
    devicePreviewBuilder.setFlocktoryId(data, currentRegion);
    devicePreviewBuilder.setDeviceName(data);
    devicePreviewBuilder.setDeviceBrandName(data);
    devicePreviewBuilder.setDeviceLink(data);
    devicePreviewBuilder.setDeviceCharacteristics(data);
    devicePreviewBuilder.setDevicePromoBadges(data);
    devicePreviewBuilder.setDeviceIsFlocktory(data, true);
    devicePreviewBuilder.setDeviceIsInBasket(data, basketIds);
    devicePreviewBuilder.setDeviceIsFavorite(data, favoriteList);
    devicePreviewBuilder.setDeviceIsCmp(data, compareList);
    devicePreviewBuilder.setDeviceBrand(data);
    devicePreviewBuilder.setDeviceArticle(data);
    devicePreviewBuilder.setDeviceCategoryId(data);
    devicePreviewBuilder.setDeviceIsPreorder(data);
    devicePreviewBuilder.setDeviceImgOptions(data);
    devicePreviewBuilder.setDeviceCapacity(data);
    devicePreviewBuilder.setDeviceColor(data);
    devicePreviewBuilder.setDeviceIsOutOfStock(data);
    devicePreviewBuilder.setDeviceReviews(data);
    devicePreviewBuilder.setDevicePromoSubscribe(data);
    devicePreviewBuilder.setDevicePromosubscribeSaleSoon(data);
    devicePreviewBuilder.setDevicePromosubscribeSalePersonalDataLink(data);
    devicePreviewBuilder.setDevicePromoBundle(data);
    devicePreviewBuilder.setDevicePromoCode(data);
    devicePreviewBuilder.setDevicePrice(data);
    devicePreviewBuilder.setDeviceOldPrice(data);
    devicePreviewBuilder.setDeviceDiscount(data);
    devicePreviewBuilder.setDeviceIsSended(data);
    devicePreviewBuilder.setDevicePromoCredit(data);
    devicePreviewBuilder.setDeviceContentType(data);
    devicePreviewBuilder.setDeviceTShirtType(data);
    devicePreviewBuilder.setDeviceTypes(data);
    devicePreviewBuilder.setBnpl(data);

    const device = devicePreviewBuilder.getDeviceData();

    dispatch(fetchDeviceDetailsDataSuccess(device));
  } catch (error) {
    captureException(error);
    dispatch(fetchDeviceDetailsDataError());
  }
};
